export default {
    join_now: 'Únase ahora',
    login: 'INICIAR SESIÓN',
    login_capital_letters: 'Iniciar sesión',
    login_capital_letters1: 'Iniciar sesión',
    summary_text: 'Tu resumen de EcoCréditos',
    membership: 'MIEMBRO',
    current_tier: 'Nivel actual',
    points: 'EcoCredits',
    points_balance: 'Saldo de EcoCréditos',
    points_progress_tips: 'EcoCréditos necesarios para alcanzar {plus}: {points} EcoCréditos',
    coming_soon: 'Próximamente',
    redeem_now: 'CANJEAR AHORA',
    points_activity: 'ACTIVIDAD DE PUNTOS',
    how_it_works: 'Cómo funciona',
    already_member: '¿Ya eres miembro?',
    already_member1: '¿Ya eres miembro?',
    sign_up: 'Registrarse',
    sign_up_desc: 'Crea una cuenta y consigue 500 EcoCréditos de recompensa.',
    sign_up_desc_h: '500 EcoCréditos cuando te inscribas.',
    earn_points: 'GANA EcoCréditos',
    earn_points_desc: 'Gana EcoCréditos con cada compra.',
    redeem_points: 'CANJEAR EcoCréditos',
    redeem_points_desc: 'Canjea EcoCréditos por descuentos exclusivos.',
    earn_points_title: 'Formas de ganar EcoCréditos',
    sign_up_text: '500 EcoCréditos al inscribirte',
    completed_text: 'Ya conseguiste esta recompensa.',
    subscribe: 'Suscribirse',
    subscribe_capital_letters: 'Suscribirse',
    subscribe_text: 'Suscríbete al boletín de EcoFlow.',
    subscribe_hover: 'Gana 500 EcoCréditos al suscribirte.',
    subscribe_now: 'Suscribirse ahora',
    email_address: 'Dirección de correo electrónico',
    shop: 'Tienda',
    shop_capital_letters: 'Tienda',
    earn_point_by_order: 'Gana cada vez que hagas un pedido.',
    earn_point_rule_shop: 'Consigue 1 EcoCréditos por cada $1 que gastes.',
    shop_to_earn_points: 'Compra para ganar EcoCréditos',
    warranty: 'Garantía',
    warranty_capital_letters: 'Garantía',
    warranty_desc1: '1000 EcoCréditos cuando registres un producto.',
    warranty_desc2: '1000 EcoCréditos cuando registres un producto.',
    profile: 'Perfil',
    profile_desc1: 'Gana hasta 1000 EcoCréditos por completar tu perfil.',
    profile_desc2: 'Gana hasta 1000 EcoCréditos por agregar tus datos.',
    complete_profile: 'Completar perfil',
    referral: 'Invitar a un amigo',
    referral_desc: 'Gana EcoCréditos por cada amigo que se registre correctamente.',
    referral_btn: 'Únase ahora',
    redeem_ecocredits_title: 'Canjear recompensas de EcoCréditos',
    have_points: 'Tienes <code>{points} EcoCréditos</code>',
    view_all: 'Ver todo',
    coupon: 'Código de descuento',
    discount: 'Descuentos',
    gift_card: 'Tarjetas de regalo',
    redeemed_succ: 'Canjeado correctamente',
    copy_desc: 'Copió el código. Vaya a la tienda para usarlo.',
    store: 'Comprar ahora',
    coupon_used_desc: 'Utilice este código al pagar para canjear su tarjeta de regalo de {amount}',
    rules: 'Reglas',
    off: 'DE DESCUENTO',
    site_rules: 'Solo para tienda de MX.',
    days_rules: 'Válido durante {days} días a partir del canje.',
    product_rules: 'Solo para {product}.',
    days_rules2: 'Válido a partir de {data}.',
    rewards_redeemed: 'Mis recompensas',
    lucky_rewards_list: 'Lista de recompensas',
    redeedmed_tab_name: 'Canjeado',
    issued_tab_name: 'Emitido',
    available: 'Disponible',
    redeemed: 'Canjeado',
    expired: 'Caducado',
    edeemed_rewards_note: 'Sus recompensas canjeadas aparecerán aquí.',
    browse_ecocredits_rewards: 'Ver recompensas de EcoCredits',
    used: 'Utilizado',
    give_away: 'Regalar',
    or_text: 'O',
    send_your_friend: 'Enviar su tarjeta de regalo de {amont} a un amigo.',
    points_activity_a: 'Mi actividad',
    points_tab_name: 'Actividad de EcoCredits',
    rewards_tab_name: 'Actividad de recompensas',
    date: 'Fecha',
    action: 'Acción',
    email: 'Email',
    rewards_title: 'Recompensas',
    type_title: 'Tipo',
    discount_type: 'Descuento',
    purchase: 'Compra',
    profile_a: 'Perfil',
    refund: 'Reembolso',
    registered: 'Registrado',
    points_capital_letters: 'EcoCredits',
    status: 'Estado',
    pending: 'Pendiente',
    received: 'Recibido',
    deducted: 'Descontado',
    view_more: 'Ver más',
    history_note: 'Su actividad de EcoCredits aparecerá aquí. ¿Todavía no ve sus EcoCredits? Su actividad se actualizará dentro de 24 horas.',
    lucky_flop_start: 'Join Now',
    lucky_flop_congrat: 'Felicitaciones',
    lucky_flop_get: 'Reclamar',
    lucky_flop_open: 'ABRIR',
    ecoflow_benefits: 'Beneficios de EcoCredits',
    membership_includes: 'LA MEMBRESÍA INCLUYE',
    see_t_c: 'Ver términos y condiciones',
    manually_added: 'Agregado manualmente',
    manually_deducted: 'Deducido manualmente',
    earning_points: 'CANJE de EcoCredits',
    network_error: 'Error de red',
    confirm_text: '¿Está seguro de que desea canjear? No se puede deshacer.',
    confirm_btn: 'Confirmar',
    no_enough_points: 'Error de canje, sus EcoCredits no son suficientes',
    no_history_note: '¿Todavía no ve sus EcoCredits? Su actividad se actualizará en 24 horas.',
    no_coupon_note: 'Aún no se ha canjeado ninguna recompensa.',
    minimum_price: 'Importe mínimo de compra ({price}).',
    minimum_num: 'Cantidad mínima de artículos({num} uds.).',
    stay_too_long: 'Su sesión ha expirado. Actualice la página e inténtelo de nuevo.',
    order_rule: 'Solo un código de descuento por pedido.',
    purchas_rule: 'Si compra un artículo por un precio inferior al del cupón, perderá la diferencia.',
    profile_birthday: 'Perfil - Cumpleaños',
    profile_address: 'Perfil - Dirección',
    profile_username: 'Perfil - Nombre de usuario',
    profile_picture: 'Perfil - Foto',
    profile_contact: 'Perfil - Información de contacto',
    membership_faq_title: 'MEMBERSHIP', //没翻译
    learn_more: 'Más información',
    profile_detail:
        'Complete su perfil para obtener hasta 1000 EcoCredits, lo que incluye foto de perfil (200), nombre de usuario (100), información de contacto (300), dirección (200) y cumpleaños (200).',
    exceeded_counts: 'No se pudo canjear. Ha superado el límite de canje.',
    grab_title: 'Obtenga una bonificación de EcoCredits',
    grab_sub_title: 'Ofertas exclusivas por tiempo limitado para miembros de EcoCredit. Haga clic para canjear ahora',
    grab_btn_text: 'Obtener mi bonificación',
    grab_success_title: 'Felicitaciones',
    grab_success_text1: 'Ha conseguido su bonificación\nPegue el código al comprar para obtener su descuento.',
    grab_success_text2: 'Revise sus bonos en <code>Mis Recompensas</code>.',
    'no-grab-content-note': 'Próximamente habrán más ofertas',
    copy_desc_2: 'Ha copiado el código.',
    city_validatino_error: 'Ciudad no válida',
    product_text: 'Producto',
    shipping_address_text: 'Dirección de envío',
    saved_address_text: 'Direcciones guardadas',
    use_new_address: 'utilizar una nueva dirección',
    spend_now: 'Gastar ahora',
    stock_left: '{stock} restante',
    no_stock_tip: 'Próximamente… Esté atento.',
    order_text: 'Pedido',
    campaign_time_limit_text: 'Período de canje válido: {startTime} - {endTime}.',
    event_action_text: 'Evento',
    warranty_minus_action_text: 'Garantía eliminada',
    question_correctly: 'Responda correctamente a la pregunta',
    referral_correctly: 'Programa de recomendación',
    confirm_btn_text: 'Cerrar',
    lucky_turntable_title: 'Tirada de la suerte',
    join_lucky_with_points: 'Una partida de tirada de la suerte cuesta {points} EcoCredits.',
    join_lucky_with_points2: 'Una partida cuesta {points} EcoCredits.',
    join_lucky_desc: '¡Gire la rueda y gane un premio!',
    remaining_number: '<code></code> giros restantes',
    remaining_number2: '<code></code> vueltas restantes',
    learn_lucky_rule: 'Conozca más sobre las reglas',
    prize_coupon_title: 'Felicitaciones',
    prize_coupon_sub_title: '¡El premio ha sido reclamado con éxito! Utilice el código al pagar para ahorrar.',
    prize_coupon_action: 'Vea sus premios en <code>Mis premios</code>.',
    prize_coupon_button: 'Comprar ahora',
    prize_points_title: 'Felicitaciones',
    prize_points_desc: 'Compruebe los EcoCredits recién agregados en <code>Mi Actividad</code>.',
    limit_times_in_day: 'Puede girar las ruletas <count></count> veces en <day></day> días.',
    limit_times_in_day2: 'Puede voltear las cartas <count></count> veces en <day></day> días',
    limit_times_in_active: 'Durante el evento, puede girar las ruletas hasta <count></count> veces.',
    without_limit_times: 'Puede girar las ruedas <count></count> veces en cualquier momento.',
    without_limit_times2: 'Puede voltear las cartas <count></count> veces en cualquier momento.',
    active_is_unstart: 'Este evento se celebrará próximamente.',
    active_is_ended: 'Este evento ha finalizado.',
    over_max_count: 'Ha superado el número de giros disponibles.',
    notice_title: 'Aviso',
    points_cash: 'Canje de puntos',
    Pending1: 'Pendiente',
    rollback: 'Devuelto',
    level_change_log: 'Nivel de actividad',
    deadline: 'Válido hasta',
    history_refresh_member: 'Nivel actual: Miembro',
    history_refresh_plus_member: 'Nivel actual: Miembro PLUSr',
    register: 'Registrarse como miembro',
    upgrade: 'Cambiar a Miembro PLUS',
    demotion: 'Cambiar a Miembro',
    relegation: 'Mantenerse como Miembro PLUS',
    ecocredits_notice1:
        'Hemos actualizado las normas de los EcoCredits el 17 de octubre de 2024. Lea atentamente nuestras [<line1>Normas de EcoCredits</line1>] actualizadas antes de utilizar sus EcoCredits.',

    wattayear_2024: 'Compartir#WattAYear',
    clock_in: '',
    copy_success1: 'You have copied the code, please go to the store to use it.', //没翻译
};
